import React from 'react'

const SuperDashboard = () => {
  return (
    <div>SuperDashboard</div>
  )
}

export default SuperDashboard